export default class i18nManager {
    constructor(){
        this.language = 'de';
        this.translations = {};
        this.cache = {};
    }
    
    
    getLanguage(){
        return this.language;
    }
    
    register(translations,projectID){
        projectID = (projectID !== undefined) ? projectID : 'dastudio';
        this.translations[projectID] = translations;
    }
        
    setLanguage(language){
        this.language = language;
    }
    
    translate(key,projectID){
        projectID = (projectID !== undefined) ? projectID : 'dastudio';
        const cacheKey = projectID+this.language+key;
        
        if (this.cache[cacheKey] === undefined) {
            if(this.translations[projectID] !== undefined 
            && this.translations[projectID][this.language] !== undefined 
            && this.translations[projectID][this.language][key] !== undefined) {
                this.cache[cacheKey] = this.translations[projectID][this.language][key]
            } else {
                this.cache[cacheKey] = key;
            }
        }
            
        return this.cache[cacheKey];
    }
}


// WEBPACK FOOTER //
// ./src/js/define/i18nManager.js